module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedExtraLight.19305b3.woff";